import React from 'react'

export const TicketsContext = React.createContext();